import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	placeholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	placeholder: {
		id: 'software-board-create.modal.form.source-value-picker.team-picker.placeholder',
		defaultMessage: 'Select',
		description: 'Placeholder text for the team picker',
	},
});
export default messages;
